<template>
    <d2-container type="card" :filename="filename">
        <el-row :gutter="20">
            <el-col :span="14">
                <el-form ref="form" :model="form" label-width="80px">
                    <el-form-item label="账户">
                        <el-input v-model="user" :disabled="true"></el-input>
                    </el-form-item>
                    <el-form-item label="原密码" prop="oldpwd" :rules="[
                     { required: true, message: '密码不能为空'},
                    { min: 5, message: '长度不够',trigger: ['blur', 'change'] }]">
                        <el-input v-model="form.oldpwd" type="password"></el-input>
                    </el-form-item>
                    <el-form-item label="新密码" prop="newpwd"
                                  :rules="[ { required: true, message: '密码不能为空'},{ min: 5, message: '长度不够',trigger: ['blur', 'change'] }]">
                        <el-input v-model="form.newpwd" type="password"></el-input>
                    </el-form-item>
                    <el-form-item label="重复密码" prop="newpwd2"
                                  :rules="[ { required: true, message: '密码不能为空'},{ min: 5, message: '长度不够',trigger: ['blur', 'change'] }]">
                        <el-input v-model="form.newpwd2" type="password"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="onSubmit" :loading="loading">修改</el-button>
                        <el-button>取消</el-button>
                    </el-form-item>
                </el-form>
            </el-col>
        </el-row>
    </d2-container>
</template>

<script>
    import util from '@/libs/util.js'

    export default {
        data() {
            return {
                filename: __filename,
                text: '<p>Hello World</p>',
                user: util.cookies.get('uuid'),
                loading: false,
                form: {
                    user: util.cookies.get('uuid'),
                    oldpwd: '',
                    newpwd: '',
                    newpwd2: ''
                }

            }
        },
        methods: {
            onSubmit() {
                this.$refs.form.validate((valid) => {
                    if (valid) {
                        const _this = this
                        if (this.form.newpwd !== this.form.newpwd2) {
                            this.$message({
                                message: '密码不相同',
                                type: 'warning'
                            });
                            return
                        }
                        this.loading = true
                        this.$request({
                            url: 'changeUserPwd.do',  data: this.form,
                        }).then(res => {
                            // this.keepAliveRemove(this.$route.name)
                            this.$nextTick(this.$router.replace('/refresh'))
                            this.$message({
                                message: '修改成功',
                                type: 'success'
                            });
                            _this.loading = false
                        })
                            .catch((error) => {
                                this.msg = error
                                _this.loading = false
                            })
                    }
                })
            }
        }
    }
</script>
